module.exports = __webpack_public_path__ + "img/primary-calendar-outline.ef5e7f2a.svg";